// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DK3p1"};